// The save bar that floats while there are changes to save, and a list beside its detail.
import type { ReactNode } from 'react';
import { Button } from './Button';
import { cx } from './cx';
import s from './Layout.module.css';

/** Floats at the bottom while there are changes: Discard and Save. */
export function SaveBar({
  dirty,
  busy = false,
  onSave,
  onDiscard,
  message = 'Unsaved changes',
  saveLabel = 'Save',
}: {
  dirty: boolean;
  busy?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  message?: string;
  saveLabel?: string;
}) {
  if (!dirty) {
    return null;
  }
  return (
    <div className={s.saveBar} role="region" aria-label="Unsaved changes">
      <span className={s.saveBarText}>{message}</span>
      <Button variant="gray" size="small" disabled={busy} onClick={onDiscard}>
        Discard
      </Button>
      <Button size="small" busy={busy} onClick={onSave}>
        {saveLabel}
      </Button>
    </div>
  );
}

/**
 * A list beside the detail of what's chosen in it, on a desktop. On a phone, one or the other: the detail when
 * something's chosen.
 */
export function SplitView({
  list,
  detail,
  showingDetail,
}: {
  list: ReactNode;
  detail: ReactNode;
  showingDetail: boolean;
}) {
  return (
    <div className={cx(s.split, showingDetail && s.showingDetail)}>
      <div className={s.splitList}>{list}</div>
      <div className={s.splitDetail}>{detail}</div>
    </div>
  );
}
